import { all, call, put, takeLatest } from 'redux-saga/effects';
import queryApi from '../../utils/fetchApi';
import Urler from '../../utils/serviceUrl';
import { claimBountyFailure, claimBountySuccess, fetchBountiesFailure, fetchBountiesSuccess } from './bounties.actions';
import bountyActionTypes from './bounties.types';

export function* fetchBounties({ payload: token }) {
    try {
        let res = yield queryApi({ method: 'GET', url: yield Urler('/bounties'), bearer: token });
        if (res.status === 'success') {
            yield put(fetchBountiesSuccess(res.data.bounties));
        } else {
            yield put(fetchBountiesFailure(res.message));
        }
    } catch (e) {
        yield put(fetchBountiesFailure(e.message));
    }
}

export function* claimBounty({ payload: { token, bountyId, evidence } }) {
    try {
        // Evidence is text or URL in this basic version
        let res = yield queryApi({
            method: 'POST',
            url: yield Urler(`/bounties/${bountyId}/claim`),
            bearer: token,
            data: { evidence }
        });
        if (res.status === 'success') {
            yield put(claimBountySuccess(res.data.claim));
        } else {
            yield put(claimBountyFailure(res.message));
        }
    } catch (e) {
        yield put(claimBountyFailure(e.message));
    }
}

export function* onFetchBountiesStart() {
    yield takeLatest(bountyActionTypes.FETCH_BOUNTIES_START, fetchBounties);
}

export function* onClaimBountyStart() {
    yield takeLatest(bountyActionTypes.CLAIM_BOUNTY_START, claimBounty);
}

export function* bountiesSagas() {
    yield all([
        call(onFetchBountiesStart),
        call(onClaimBountyStart)
    ]);
}
